import { render, staticRenderFns } from "./AvailableBoxesModal.vue?vue&type=template&id=1599bf7a&scoped=true&lang=pug&"
import script from "./AvailableBoxesModal.vue?vue&type=script&lang=js&"
export * from "./AvailableBoxesModal.vue?vue&type=script&lang=js&"
import style0 from "./AvailableBoxesModal.vue?vue&type=style&index=0&id=1599bf7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1599bf7a",
  null
  
)

export default component.exports